import publicService from 'api/public';

const handleError = (error) => {
  let result = error;

  if (typeof error.json === 'function') {
    error
      .json()
      .then((errorJson) => {
        result = errorJson;
      })
      .catch(() => {
        result = error;
      });
  } else {
    result = error;
  }

  return result;
};

export default {
  sendDownloadAppLinkOnSMS: (phoneNumberInformation) => new Promise((resolve, reject) => {
    publicService
      .postDownloadAppSMS(phoneNumberInformation)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        const errorInfo = handleError(error);

        reject(errorInfo);
      });
  }),
};
